import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../context-store";
import Layout from "../../components/layout/Layout";
import "../../assets/InnerCSS/plugins/bootstrap/css/bootstrap.min.css";
import "../../assets/InnerCSS/plugins/font-awesome/css/font-awesome.min.css";
import "../../assets/InnerCSS/plugins/icomoon/style.css";
import "../../assets/InnerCSS/plugins/uniform/css/default.css";
import "../../assets/InnerCSS/plugins/switchery/switchery.min.css";
import "../../assets/InnerCSS/plugins/nvd3/nv.d3.min.css";
import "../../assets/InnerCSS/css/styles.css";
import "../../assets/InnerCSS/css/custom.css";
import CompanyProfileComponent from "../../components/company/company-profile/CompanyProfileComponent";
import modalUtils from "../../utils/modal-utils";
import { useHistory } from "react-router";
import companyDashboardService from "../../services/company/dashboard-service";
import CompanyProfileRequest from "../../models/company/dashboard/request/CompanyProfileRequest";
import toasterUtils from "../../utils/toaster-utils";

const companyProfileModelDefault = {
    companyId: "",
    mobileNumber: 0,
    website: "",
    contactPersonName: "",
    contactPersonEmailId: "",
    contactPersonPhoneNumber: 0,
    address: "",
    resumeTitle: "",
};

const CompanyDashboard = () => {
    const history = useHistory();
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [companyProfile, setCompanyProfile] = useState<CompanyProfileRequest>(companyProfileModelDefault);
    const [refreshCompanyProfile, setRefreshCompanyProfile] = useState<number>(2);

    useEffect(() => {
        if (loggedInUser) {
            getCompanyProfile(loggedInUser.profileId);
        }
    }, []);

    const getCompanyProfile = (companyId: string) => {
        modalUtils.showLoader();
        companyDashboardService.getCompanyProfile(companyId).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setCompanyProfile(res.data);
            setRefreshCompanyProfile(refreshCompanyProfile * 2);
        }).catch((error) => {
            setRefreshCompanyProfile(refreshCompanyProfile * 2);
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    return (
        <Layout>
            <div className="breadcrumb-text">
                <a onClick={() => history.push("/")}>Home</a> <i className="fa-solid fa-angle-right"></i> Company Profile
            </div>
            <div className="page-title">
                <h4 className="breadcrumb-header"> COMPANY PROFILE </h4>
            </div>
            {refreshCompanyProfile > 2 &&
                <CompanyProfileComponent key={refreshCompanyProfile}
                    objCompanyProfile={companyProfile} />
            }
        </Layout>
    );
};
export default CompanyDashboard;